import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import addVisibilityObserver from '@/js/components/useVisibilityObserver';
import BaseComponent from './baseComponent';

gsap.registerPlugin(ScrollTrigger);

export default class HeaderHeroFullBackground extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.el = document.querySelector('[data-header-hero-full-background]');
    this.debug = false;

    if (this.el) {
      this.pageHeader = document.querySelector('.page-header');
      this.content = this.el.querySelector('.content');
      this.background = this.el.querySelector('.background');
      this.backgroundBackground = this.el.querySelector('.background > .image.-background');
      this.backgroundForeground = this.el.querySelector('.background > .image.-foreground');
      this.isVida = this.el.dataset.headerHeroFullBackground === 'vida';
    }
  }

  init() {
    if (!this.el) {
      return;
    }

    addVisibilityObserver(this.el, {
      onFirstEnter: () => {
        console.log('HeaderHeroFullBackground initialised');
        this.animation();
        this.fadeInTitle();
      },
    }, {
      // rootMargin: '-500px',
      threshold: 0,
    });
  }

  fadeInTitle() {
    gsap.to('.animatein', {
      y: 0, opacity: 1, duration: 1.25, ease: 'power2.out', stagger: 0.125,
    });

    return this;
  }

  animation() {
    const mm = gsap.matchMedia();

    mm.add('(max-width: 991px)', () => {
      this.el.classList.remove('-animated-version');
      this.el.style.marginTop = '';
      this.el.style.setProperty('--header-hero-full-background-header-height', '0px');
    });

    // The following scroll-animation only runs on viewport large
    mm.add('(min-width: 992px)', () => {
      this.el.classList.add('-animated-version');
      this.el.style.marginTop = `-${this.pageHeader?.offsetHeight}px`;
      this.el.style.setProperty('--header-hero-full-background-header-height', `${this.pageHeader?.offsetHeight}px`);

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this.el,
          markers: this.debug,
          start: 'top top',
          end: () => '+=250', // this is additional distance from bottom.
          pin: true,
          pinSpacing: true,
          scrub: 0.5, // true or seconds,
        },
      });

      timeline
        .to(this.backgroundBackground, { translateY: (this.pageHeader?.offsetHeight - 60) * -1, duration: 5 }) // eslint-disable-line max-len
        .to(this.backgroundForeground, { translateY: (this.pageHeader?.offsetHeight - 30) * -1, duration: 5 }, '<');

      // In case we need two different timelines:
      // if (this.isVida) { ... }
    });

    ScrollTrigger.refresh();

    window.addEventListener('resize', () => ScrollTrigger.refresh());
    window.addEventListener('load', () => ScrollTrigger.refresh());

    return this;
  }
}
